module.exports = __webpack_public_path__ + "img/top-bg-1.5c12f44c.png";